export default function (close, notes) {
    const vm = this;

    vm.records = notes;

    vm.closeModal = close;
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/notes/list/noteListCtrl.js